
import React from "react"
import Icon from "../icon.component"
import "../styles/iconStyles.scss"

const InfoIcon = () => {
    return (
        <Icon 
            value={"info"} 
            className={"info-icon"} 
            size={"10px"} 
        />
    )
}

export default InfoIcon


// WEBPACK FOOTER //
// ./src/common/icon/icons/InfoIcon.tsx